/* 分享函数库 */
import config from '@/config/config'

const jsApiList = [
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'updateAppMessageShareData',
  'updateTimelineShareData',
]

export function registerWxConfig(url, {apiList = jsApiList, cb = () => {}} = {}) {
  // let url = window.location.href
  let rand = Math.floor(Math.random() * 10000)
  $.ajax({
    type: 'POST',
    dataType: 'jsonp',
    url: 'https://m.idaddy.cn/ad/wxShareConfig.php?comeback=jsonp&rand=' + rand,
    data: { url: url },
    success: result => {
      let appId = result.appId
      let timestamp = result.timestamp
      let nonceStr = result.nonceStr
      let signature = result.signature
      // fuck weixin
      wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: apiList
      })
      wx.ready(cb)
    }
  })
}
// 分享时写全路径，不要利用vue自身路由进行分配（ios的分享问题）
export function setWxShare({title = '口袋故事APP', desc = '3500万妈妈选择的儿童精品内容平台', link = `${config.siteRoot}/buyvip`, imgUrl = `${config.siteRoot}/logo.jpg`} = {}, cb = () => {}) {
  wx.onMenuShareAppMessage({
    title: title,
    desc: desc,
    link: link,
    imgUrl: imgUrl,
    success: cb
  })
  wx.onMenuShareTimeline({
    title: title,
    desc: desc,
    link: link,
    imgUrl: imgUrl,
    success: cb
  })
}
